module.exports = __webpack_public_path__ + "static/media/suggestedAliasDesktop.40692684.svg";